import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FeatherIconsComponent } from '../../../shared/components/feather-icons/feather-icons.component';

@Component({
  selector: 'app-product-header',
  standalone: true,
  imports: [RouterModule,FeatherIconsComponent,CommonModule],
  templateUrl: './product-header.component.html',
  styleUrl: './product-header.component.scss'
})

export class ProductHeaderComponent {

  public isOpen : boolean = false;

}
